import { Logo, LogoWrapper } from './styles'
import Img from '../../asset/kbc_logo.png'

const EventLogo = () => {
	return (
		<LogoWrapper>
			<Logo src={Img} alt="logo_indian_idol_marathi" />
		</LogoWrapper>
	)
}

export default EventLogo
